export type ContactType = "call" | "text" | "booking";

export async function logContact(
  contact_type: ContactType,
  payload: { name?: string; phone?: string; appliance?: string; problem?: string } = {},
) {
  try {
    await fetch("/api/public/contact-log", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      keepalive: true,
      body: JSON.stringify({
        contact_type,
        name: payload.name ?? null,
        phone: payload.phone ?? null,
        appliance: payload.appliance ?? null,
        problem: payload.problem ?? null,
      }),
    });
  } catch (err) {
    // Non-blocking: never interrupt user flow
    console.error("logContact failed", err);
  }
}
